module.exports = __webpack_public_path__ + "static/cssom-05c44fa5586b8bab18091e543f7a06f4.png";